import React, { useState, useEffect, useRef } from 'react'
import Img from 'gatsby-image'
import './Clients.css'

function Clients({ clients }) {
  const clientLogos = clients[0].node.clientLogos // fonte original

  // initial split
  const VISIBLE_COUNT = 8
  const initialVisible = clientLogos.slice(0, VISIBLE_COUNT)
  const initialInvisible = clientLogos.slice(VISIBLE_COUNT)

  // state for rendering
  const [visibleLogos, setVisibleLogos] = useState(initialVisible)
  const [invisibleLogosState, setInvisibleLogosState] = useState(
    initialInvisible
  )

  // refs for mutable data
  const visibleRef = useRef(initialVisible)
  const invisibleRef = useRef(initialInvisible)
  const visIndexRef = useRef(0)

  // animation
  const [fadeOutId, setFadeOutId] = useState(-1)
  const [fadeInId, setFadeInId] = useState(-1)
  const [fadeInActiveId, setFadeInActiveId] = useState(-1)

  // helper delay
  function delay(duration) {
    return new Promise(resolve => setTimeout(resolve, duration))
  }

  useEffect(() => {
    const v = clientLogos.slice(0, VISIBLE_COUNT)
    const inv = clientLogos.slice(VISIBLE_COUNT)
    visibleRef.current = v
    invisibleRef.current = inv
    setVisibleLogos(v)
    setInvisibleLogosState(inv)
    visIndexRef.current = 0
  }, [clientLogos])

  useEffect(() => {
    const interval = setInterval(() => {
      ;(async () => {
        setFadeInId(-1)
        setFadeInActiveId(-1)

        const inv = invisibleRef.current
        const v = visibleRef.current

        if (!inv || inv.length === 0 || !v || v.length === 0) {
          return
        }

        const idx = visIndexRef.current

        // fade out
        setFadeOutId(idx)
        await delay(1000)

        // change items
        const newVisible = [...v] // copy visibles
        const newInvisible = [...inv] // copy invisibles

        // incoming
        const incoming = newInvisible.shift() // remove first item
        const outgoing = newVisible[idx] // item would be removed

        newVisible[idx] = incoming
        newInvisible.push(outgoing)

        visibleRef.current = newVisible
        invisibleRef.current = newInvisible

        setVisibleLogos(newVisible)
        setInvisibleLogosState(newInvisible)

        // fade in
        await delay(10)
        setFadeInId(idx)
        setFadeOutId(-1)

        await delay(10)
        setFadeInActiveId(idx)

        // update index
        visIndexRef.current = (idx + 1) % newVisible.length
      })()
    }, 3000)

    return () => clearInterval(interval)
  }, [])

  return (
    <section className="ClientContainer">
      <h2 className="ClientListTitle">Clients</h2>
      <ul className="ClientList">
        {visibleLogos.map((visibleLogo, index) => (
          <li key={visibleLogo.id}>
            <div
              className={`logoContainer ${
                fadeOutId === index ? 'list-transition-exit' : ''
              } ${fadeInId === index ? 'list-transition-enter' : ''} ${
                fadeInActiveId === index ? 'list-transition-enter-active' : ''
              }`}
            >
              <Img fluid={visibleLogo.fluid} />
            </div>
          </li>
        ))}
      </ul>
    </section>
  )
}

export default Clients
